module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHBAMAAADDgsFQAAAAGFBMVEUAAADx8/Tx8/Tx8/Tx8/Tx8/Tx8/Tx8/TgcsBBAAAAB3RSTlMAB+q2tyskmH7l9QAAAC5JREFUCNdjYGAQZAACRhMBIClc7ghkmisVCzAIF4WqGzKIqDIEOTIwJjCwCQAATNwEdB5g3SMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_up1.png
// module id = TP77
// module chunks = 9